
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"m20 24h-16c-2.2 0-4-1.8-4-4v-16c0-2.2 1.8-4 4-4h6v2h-6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-6h2v6c0 2.2-1.8 4-4 4z"}}),_c('path',{attrs:{"d":"m10.1382 13.869 1.7094-.4872 10.2925-10.28913c.0812-.08219.1264-.19262.1258-.30745-.0005-.11482-.0468-.22483-.1287-.30626l-.6164-.61562c-.0399-.04044-.0875-.07262-.14-.09469-.0526-.02207-.1091-.03357-.1662-.03384-.0571-.00026-.1137.01071-.1664.03228-.0528.02157-.1007.05331-.1409.09337l-10.2653 10.26234-.5048 1.7452zm12.6027-13.225404.6165.616584c.8503.85056.8581 2.22276.0155 3.06469l-10.606 10.60373-3.6538 1.0394c-.22307.0617-.46181.0334-.66381-.0786-.20201-.112-.35078-.2985-.41368-.5188-.04681-.1583-.04748-.3265-.00195-.4852l1.06294-3.6822 10.5779-10.575906c.2011-.20007.4406-.358575.7044-.46627.2638-.1076953.5466-.16242489.8321-.16099675.2854.00142813.5677.05898545.8304.16931475.2627.110329.5005.272181.6995.474254z"}}),_c('path',{attrs:{"d":"m9 1c0-.552285.44772-1 1-1 .5523 0 1 .447715 1 1 0 .55228-.4477 1-1 1-.55228 0-1-.44772-1-1z"}}),_c('path',{attrs:{"d":"m22 14c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1z"}})])])
          )
        }
      }
    